import React from 'react';
import '../less/main.less';
import { apiback } from "../../../../config";
import share_icon from "../../../../pages/Cards/ProjectSupport/img/share_icon.svg";
import {Link} from 'MWC';

export default function template() {
    const { title, children, id, link, subtitle, l10n, titleTag } = this.props,
        formatHTML = value => l10n ? this.l10n(value) : value,
        detailedText = this.props.showDetails ?
            <div className="detailed">{this.l10n("CUSTOMDROPDOWN_DETAILED")}</div>
            : null,
        TitleTag = titleTag || "div"

    return (
        <>
            <div id={this.props.data?.id} className={`dropdown ${(this.props.data ? this.props.data.active[this.props.data.id] : this.state.active) ? 'active' : ''}`} onClick={this.toggleActive}>
                <div className={`left-side ${link ? 'linked' : ''}`} >
                    <TitleTag className="dropdown-title" dangerouslySetInnerHTML={{ __html: formatHTML(title) }} />
                      {link ?
                        <Link
                          href={link}
                          target={'_blank'}>
                          <img alt="href_img" src={share_icon}/>
                        </Link>
                    :
                    ''}
                    {subtitle ? <div className="dropdown-subtitle" dangerouslySetInnerHTML={{ __html: formatHTML(subtitle) }} /> : ''}
                </div>
                <div className="right-part">
                    {detailedText}
                    <div className="dropdown-arrow" />
                </div>
            </div>
            <div className={`dropdown-items`}>{children}</div>
        </>
    );
}
